import baseApi from "./baseApi";

const endpoint = "dashboard";

export default {
    dashboard: () => baseApi.get(endpoint),
};
